import React from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { setScreenType, useCallNumber } from '../../../store/slices/dialSlice';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import { useUserDetails } from '../../../store/slices/authSlice';
import { convertToMask } from '../../../utils/common';
import { useTranslation } from 'react-i18next';

const TransferScreen = ({ number }) => {
  const { t } = useTranslation();
  const user = useUserDetails();
  const callNumber = useCallNumber();

  const dispatch = useDispatch();

  return (
    <div className="h-100 call-action-btn-container">
      <div className="mt-auto mb-auto text-white text-center fw-bold fs-4">
        {user?.process_details?.numberMasking === 'true'
          ? convertToMask(callNumber || number)
          : callNumber || number}
      </div>

      <div className="text-center text-white transfer-call-button-grid mb-auto">
        <div className="d-flex flex-column align-items-center">
          <Button
            color="dark"
            className="mb-1"
            onClick={() => dispatch(setScreenType('AGENT_TRANSFER'))}>
            <i className="bi bi-telephone-inbound-fill" />
          </Button>
          <span>{t('agentTransfer')}</span>
        </div>
        <div className="d-flex flex-column align-items-center">
          <Button color="dark" className="mb-1">
            <i className="bi bi-telephone-outbound-fill" />
          </Button>
          <span>{t('externalTransfer')}</span>
        </div>
      </div>
      <div className="call-button-wrapper mt-auto pb-4">
        <Button
          className="back-button"
          onClick={() => {
            dispatch(setScreenType('LIVE_CALL'));
          }}>
          <Icon.ArrowLeft className="back-icon text-primary" />
        </Button>
      </div>
    </div>
  );
};

TransferScreen.propTypes = {
  number: PropTypes.string
};

export default TransferScreen;
